// Helper: Debounce function to prevent rapid-fire submissions
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    if(facetForm) facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    
    // Select ALL product counts (sidebar + bottom footer)
    const countContainers = document.querySelectorAll('.product-count');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const productGrid = document.getElementById('ProductGridContainer').querySelector('.collection');
    
    if(productGrid) productGrid.classList.add('loading');
    
    // Add loading state to all count containers
    countContainers.forEach(container => container.classList.add('loading'));
    if (countContainerDesktop) countContainerDesktop.classList.add('loading');

    // FIX 1: Force Update "All" Button State
    FacetFiltersForm.updateGreenBarState(searchParams);

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  // --- HELPER: Controls the Custom Skin Type "All" Pill ---
  static updateGreenBarState(searchParams) {
    const allPill = document.getElementById('SkinPillAll');
    if (!allPill) return;

    // Check if there are active filters
    const hasFilters = searchParams.includes('filter.');

    if (hasFilters) {
        allPill.classList.remove('active');
    } else {
        allPill.classList.add('active');
    }
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    const newProductGridContainer = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer');
    if(newProductGridContainer) {
      document.getElementById('ProductGridContainer').innerHTML = newProductGridContainer.innerHTML;
    }
  }

  static renderProductCount(html) {
    const parser = new DOMParser().parseFromString(html, 'text/html');

    // --- FIX 2: Update ALL .product-count containers ---
    const newCounts = parser.querySelectorAll('.product-count');
    const currentCounts = document.querySelectorAll('.product-count');

    currentCounts.forEach((currentContainer, index) => {
        if (newCounts[index]) {
            currentContainer.innerHTML = newCounts[index].innerHTML;
            currentContainer.classList.remove('loading');
        }
    });

    const newDesktopCount = parser.getElementById('ProductCountDesktop');
    const currentDesktopCount = document.getElementById('ProductCountDesktop');
    if (newDesktopCount && currentDesktopCount) {
      currentDesktopCount.innerHTML = newDesktopCount.innerHTML;
      currentDesktopCount.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
     parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormCustom .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');

    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const targetElement = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
      if(targetElement) targetElement.innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.mobile-facets__heading', '.facets__heading__wrapper', '.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      
      const target = document.querySelector(selector);
      if(target) target.innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      const target = document.querySelector(selector);
      if(target) target.innerHTML = html.querySelector(selector).innerHTML;
    });

    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    if(mobileForm) mobileForm.closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    const productGrid = document.getElementById('product-grid');
    return [
      {
        section: productGrid ? productGrid.dataset.id : '',
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);   
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.target.classList.contains('mobile-facets__checkbox')) {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm' || form.id === 'FacetFiltersFormCustom') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }

  // --- NEW: Infinite Scroll Logic ---
  static initInfiniteScroll() {
    // We target the footer container where the button lives
    // Using querySelectorAll in case there are multiple, but usually we want the last one (footer)
    const containers = document.querySelectorAll('.product-count');
    const footerContainer = containers[containers.length - 1]; 

    if (!footerContainer) return;

    // 1. Create the Observer to click the button
    const observerCallback = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const btn = entry.target;
          // Click only if not already loading/disabled
          if (btn && !btn.disabled && !btn.classList.contains('loading')) {
             btn.click();
             btn.classList.add('loading'); // Optional visual feedback
          }
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, {
      root: null,
      rootMargin: '0px 0px 50px 0px', // Trigger 400px before reaching the button
      threshold: 0
    });

    // 2. Function to find and observe the button
    const observeButton = () => {
      const loadMoreBtn = footerContainer.querySelector('.load-more, .load-more-btn');
      if (loadMoreBtn) {
        observer.observe(loadMoreBtn);
      }
    };

    // 3. Initial Observation
    observeButton();

    // 4. MutationObserver to re-attach when DOM updates (e.g. after Load More click or Filter)
    const mutationObserver = new MutationObserver(() => {
      observeButton();
    });

    mutationObserver.observe(footerContainer, { childList: true, subtree: true });
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class SortDropdrown extends FacetFiltersForm {
  constructor() {
    super();
    this.select = this.querySelector('select');
    this.overlay = this.querySelector('.custom-select__overlay');
    this.newSelect = document.createElement("DIV");
    this.newSelect.setAttribute("class", "custom-select");
    this.selectText = document.createElement("span");
    this.selectText.classList.add('custom-select__text');
    this.selectText.innerHTML = this.select.options[this.select.selectedIndex].innerHTML;
    this.newSelect.append(this.selectText);
    this.prepend(this.newSelect);

    this.newOptions = document.createElement("DIV");
    this.newOptions.setAttribute("class", "custom-select__options");
    Array.from(this.select.options).forEach((option, i) => {
      const button = document.createElement("BUTTON");
      button.innerHTML = option.innerHTML;
      button.addEventListener("click", e => this.clickOnOption(e, i, option));
      this.newOptions.append(button);
    });
    this.newSelect.append(this.newOptions);
    this.newSelect.addEventListener("click", e => this.toggleDropdown(e));

    this.overlay.addEventListener('click', e => this.toggleDropdown(e));
  }
  
  clickOnOption(e, i, option) {
    e.preventDefault();
    if(this.select.options[i].innerHTML == option.innerHTML) {
      this.select.selectedIndex = i;
      this.newSelect.innerHTML == option.innerHTML;
    }
    this.select.click();
    this.onSubmitHandler(e);
  };

  toggleDropdown(e) {
    e.stopPropagation();
    this.newSelect.classList.toggle('open');
  }
}

customElements.define('sort-dropdown', SortDropdrown);

// --- MAIN INITIALIZATION ---
document.addEventListener('DOMContentLoaded', () => {
  // 1. Set Green Bar State
  FacetFiltersForm.updateGreenBarState(window.location.search);

  // 2. Initialize Infinite Scroll
  FacetFiltersForm.initInfiniteScroll();

  // 3. Bind Click Event for ALL Button (Green Bar)
  const allPill = document.getElementById('SkinPillAll');
  if (allPill) {
    allPill.addEventListener('click', (e) => {
        e.preventDefault();
        const url = new URL(window.location.href);
        url.search = ''; 
        history.pushState({ searchParams: '' }, '', url.toString());
        FacetFiltersForm.renderPage('', null, false);
    });
  }
});